/**
 * @fileoverview Teacher Invite Signup page wrapper
 * @description Page for teachers to complete signup via invitation link
 * Route: /hello-teacher/:token
 */

import { useForceEnglish } from 'hooks'
import { NotificationProvider } from 'context'
import { SchoolLogoColor } from '@legacy/common/types/whitelabel'
import Logo from '@legacy/common/components/shared/Logo'
import IllustrationSrc from '@legacy/assets/images/signup-illustration.webp'
import { InviteSignup } from './components/InviteSignup'
import {
  PageContainer,
  LogoContainer,
  ContentWrapper,
  IllustrationColumn,
  IllustrationImage,
  FormColumn,
} from './styles'

/**
 * Teacher Invite Signup page with two-column layout
 */
export const TeacherInviteSignup = () => {
  useForceEnglish()

  return (
    <NotificationProvider>
      <PageContainer>
        <LogoContainer>
          <Logo color={SchoolLogoColor.Primary} />
        </LogoContainer>
        <ContentWrapper>
          <IllustrationColumn>
            <IllustrationImage src={IllustrationSrc} alt='Signup illustration' />
          </IllustrationColumn>
          <FormColumn>
            <InviteSignup />
          </FormColumn>
        </ContentWrapper>
      </PageContainer>
    </NotificationProvider>
  )
}
